import { render, staticRenderFns } from "./AdminsTable.vue?vue&type=template&id=afd54e66"
import script from "./AdminsTable.vue?vue&type=script&lang=js"
export * from "./AdminsTable.vue?vue&type=script&lang=js"
import style0 from "./AdminsTable.vue?vue&type=style&index=0&id=afd54e66&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VDataTable,VSpacer,VToolbar})
